import KJUR from 'jsrsasign';

// Proper JWT encoding with HMAC-SHA256
export const encodeJWT = (payload, secret) => {
  const header = { alg: 'HS256', typ: 'JWT' };
  
  // Create JWT token using jsrsasign
  const sHeader = JSON.stringify(header);
  const sPayload = JSON.stringify(payload);
  
  const token = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, secret);
  
  return token;
};
